<template>
	<CurvesPage class="curve" @onScale="drawLine">
		
		<!-- Название кривой -->
		
		<template #curveName>Логарифмическая спираль</template>
		
		<!-- модуль Характеристика кривой -->
		
		<template #curveFeature>
			
			<h5>Геометрическое место точек:</h5>
			<img src="@/assets/img/logarithmic_gmt.gif" class="feature__gmt">
			<p class="feature__gmt">
				<strong>Логарифмическая спираль</strong>
				- траектория точки <vue-mathjax :formula="viewExpression('M')" class="formula"></vue-mathjax>, движущейся
				по равномерно вращаемуся вокруг точки <vue-mathjax :formula="viewExpression('O')" class="formula"></vue-mathjax>
				лучу <vue-mathjax :formula="viewExpression('OV')" class="formula"></vue-mathjax> со скоростью, пропорциональной
				расстоянию<vue-mathjax :formula="viewExpression('OM')" class="formula"></vue-mathjax>.
			</p>
			
			<!-- Уравнение в полярных координатах -->
			
			<h5 class="mt-0">
				Полярное уравнение:
				<b-badge variant="light" class="curve__main-formula">
					<vue-mathjax
							:formula="equationInPolar"
							class="formula"
					></vue-mathjax>
				</b-badge>
			</h5>
			
			<!-- Уравнение в декартовых координатах -->
			
			<h5>Параметрическое уравнение:</h5>
			<p>
				<vue-mathjax
						:formula="equationParamInCartesian" class="formula"></vue-mathjax>
			</p>
			
			<!-- Область значений для параметра -->
			
			<h5 class="mt-0">Область значений <vue-mathjax :formula="parameterT" class="formula"></vue-mathjax>:</h5>
			
			<!--
				Параметры ползунка для выбора ОДЗ параметра (!Заполнить!)
				min - минимальная левая граница
				max - максимальная правая граница
				interval - шаг, с которым можно выбирать
				Для того, чтобы блокировать точки используй
				:dot-options="tDotOptions" для тега
				tDotOptions: [{            для data()
          disabled: false
        }, {
          disabled: true
        }]
			-->
			<vue-slider
					v-model="t"
					:min="0"
					:max="20"
					:interval="1"
					@dragging="drawLine"
			></vue-slider>
			<p>
				<vue-mathjax :formula="rangeODZ" class="formula"></vue-mathjax>
			</p>
			
			<!-- Значения коэффициентов -->
			
			<h5>Зависимость от коэффициентов:</h5>
			
			<!-- Коэффициент a -->
			
			<label>
				<vue-mathjax :formula="coefficientA" class="formula"></vue-mathjax>:
			</label>
			
			<b-form-spinbutton v-model="a" min="0" max="2" step="0.1" @input="drawLine" vertical class="curve__coef"></b-form-spinbutton>
			
			<!-- Коэффициент b -->
			
			<label>
				<vue-mathjax :formula="coefficientB" class="formula"></vue-mathjax>:
			</label>
			
			<b-form-spinbutton v-model="b" min="-100" max="100" vertical @input="drawLine" class="curve__coef"></b-form-spinbutton>
		
		</template>
		
		<!-- модуль Информация о кривой -->
		
		<!-- Изображение для модуля информации -->
		
		<template #curvePhoto>
			<!--	<img src="@/assets/img/archimed2.png" width="100" alt="Архимед">-->
		</template>
		
		<!-- Контент -->
		
		<template #curveInfo>
			<h5>История</h5>
			<p>Логарифмическая спираль была впервые описана <b><i>Декартом</i></b> и позже интенсивно исследована <b><i>Бернулли</i></b>,
				который называл её <i>Spira mirabilis</i> — «удивительная спираль». Декарт искал кривую, обладающую свойством, подобным
				свойству окружности, так чтобы касательная в каждой точке образовывала с радиус-вектором в каждой точке один и
				тот же угол. Он показал, что это условие равносильно тому, что полярные углы для точек кривой пропорциональны
				логарифмам радиус-векторов.
			</p>
			<h5>Интересные факты</h5>
			<ul>
				<li>Якоб Бернулли хотел, чтобы на его могиле была выгравирована логарифмическая спираль, но вместо этого по
					ошибке на его надгробие поместили архимедову спираль. Тем не менее, надпись на латыни, выгравированная
					согласно завещанию вокруг спирали, <i>«EADEM MUTATA RESURGO»</i> («изменённая, я вновь воскресаю»), свидетельствует
					о том, что имеется в виду именно логарифмическая спираль, которая обладает замечательным свойством
					восстанавливать свою форму после различных преобразований.</li>
			</ul>
			
			<h5>В природе</h5>
			<img src="@/assets/img/logarithmic_nature.jpg" class="info__picture info__nature">
			<img src="@/assets/img/logarithmic_nature2.jpg" class="info__picture info__nature">
		</template>
		
		<!-- модуль Задачи -->
		
		<template #curveTasks>
			<h5 class="mt-0">Примеры задач:</h5>
		</template>
	
	</CurvesPage>
</template>

<script>
	import CurvesPage, { CurvesInterface } from '@/views/templates/CurvesPage';
	
	export default {
		name: 'LogarithmicSpiral',
		mixins: [CurvesInterface],
		data () {
			return {
				/* Коэффициенты уравнения */
				a: 0,
				b: 0,
				/* ОДЗ параметра */
				t: [0, 5]
			}
		},
		computed: {
			/* Функции для представления в latex
			 * rangeODZ - ОДЗ параметра
			 * equationInPolar - Уравнение в полярных координатах
			 * equationInCartesian - Уравнение в декартовых координатах
			 * equationParamInCartesian - Параметрическое уравнение
			  * http://scask.ru/j_dict_math.php?id=526*/
			rangeODZ: ({ t }) => {
				return '$$' + t[0] + ' \\pi < t < ' + t[1] + ' \\pi$$';
			},
			equationInPolar: () => {
				return '$$r= a^{ \\theta } + b$$';
			},
			equationParamInCartesian: () => {
				return '$$\\begin{cases}x=(a^{ t } + b) \\cos t \\\\ y=(a^{ t } + b) \\sin t \\end{cases}$$';
			},
			/* Свойство ОДЗ */
			maxTheta: ({ t }) => {
				return t[1] * Math.PI;
			},
			minTheta: ({ t }) => {
				return t[0] * Math.PI;
			}
		},
		methods: {
			/**
			 * Возвращает значение x при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			X (t) {
				return 160 + ((Math.pow(this.a, t) + this.b) * Math.cos(t)) * this.$store.state.step;
			},
			/**
			 * Возвращает значение y при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			Y (t) {
				return 160 - ((Math.pow(this.a, t) + this.b) * Math.sin(t)) * this.$store.state.step;
			}
		},
		components: {
			CurvesPage
		}
	}
</script>

<style scoped lang="scss">

</style>
